import React from 'react';
// components
import Header from '../../components/Header/Header';
import Breadcrumbs from '../../components/Breadcrumbs';
import AddServiceForm from './AddServiceForm';

// icons
import icon from '../../brand/generated/sidebar/services.svg';
import { useNavigate } from 'react-router-dom';

const AddService = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header title="Новая услуга" icon={icon} />
      <Breadcrumbs navigate={'/services'} link={'Дополнительные услуги'} currentPage={'Новая услуга'} />
      <AddServiceForm
        onSuccess={() => {
          setTimeout(() => {
            navigate('/services');
          }, 1000);
        }}
      />
    </>
  );
};

export default AddService;
